import React from "react";

export interface TextInputProps {
  value: any[];
  onChange: (values: any[]) => void;
  isDisabled?: boolean;
  isSummary?: boolean;
  onKeyUp?: React.KeyboardEventHandler<HTMLInputElement> | null;
  type?: string | null;
  min?: number | string | null;
  max?: number | string | null;
  placeholder?: string;
  maxLength?: number | null;
}

export default function TextInput({
  value,
  onChange,
  isDisabled = false,
  isSummary = false,
  onKeyUp = null,
  type = null,
  min = null,
  max = null,
  placeholder = "",
  maxLength = null,
}: TextInputProps) {
  return (
    <input
      style={{
        height: 40,
        ...(isSummary && {
          width: `calc(${(value[0] || "").length}ch + 60px)`,
          background: "transparent",
        }),
      }}
      disabled={isDisabled || isSummary}
      className="form-control"
      value={value[0] ?? ""}
      onChange={(e) => onChange([e.target.value])}
      onKeyUp={onKeyUp ?? undefined}
      type={type ?? undefined}
      min={min ?? undefined}
      max={max ?? undefined}
      placeholder={placeholder}
      maxLength={maxLength ?? undefined}
    />
  );
}
